export default __webpack_public_path__ + "static/media/Rolling-2.4s-200px.30feb443.gif";